import { Component } from '@angular/core';
import { MobileCard } from './mobile-card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './mobile-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class MobileCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: MobileCard[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  public formatBlocksDate(date): string {
    if (date.blocks != null && date.blocks.length) {
      return date.blocks[0].startDate;
    }
    return '-';
  }

  public isRemovable(data): string {
    if (data.blocks != null) {
      return data.blocks[0].removable ? 'Ja' : 'Nee';
    }

    return '-';
  }
}
